<template>
    <div>
      <div class="form-group registration">
        <pincode
            :target="phone"
            :channel="phoneChannel"
            :channel-target="currentPhoneTarget"
            :resend-interval="resendInterval"
            :on-resend="sendPhoneRequest"
            :start-timer="setStartTimer"
            :support-button="true"
            @pinready="setPin"/>
        <input
            type="hidden"
            id="token"
            name="token"
            :value="pin"
            required="required"
        />
        <i18n v-if="hasError" val="confirmationFailed" class="text-red"></i18n>
        <thumbnail2fa
            :is-s-m-s-panel="isSMSPanel"
            :is-flash-call-panel="isFlashCallPanel"
            :is-voice-call-panel="isVoiceCallPanel" />
      </div>
      <modal2fa
          v-if="showCallModal"
          :is-s-m-s="isSMS"
          :is-flash-call="isFlashCall"
          :is-voice-call="isVoiceCall"
          :close-call-modal="closeCallModal"
          :send-phone-modal-request="sendPhoneModalRequest"/>
    </div>
</template>

<script>
import I18n from '../i18n';
import Pincode from "../pincode.vue";
import Thumbnail2fa from "components/thumbnail2fa.vue";
import Modal2fa from "components/modal2fa.vue";

export default {
    components: {Thumbnail2fa, Modal2fa, Pincode, I18n},
    props: {
      phone: String,
      requestId: String,
      initialChannel: String,
      currentChannel: String,
      hasError: Boolean,
    },
    data: function () {
        return {
            pin: null,
            phoneChannel: "",
            currentPhoneTarget: "",
            resendInterval: 60,
            isSMS: false,
            isSMSPanel: false,
            isFlashCall: false,
            isFlashCallPanel: false,
            isVoiceCall: false,
            isVoiceCallPanel: false,
            showCallModal: false,
            setStartTimer: true,
            phoneChannelActions: {
              SMS: {
                name: 'SMS',
                requestDebounce: this.sendSmsDebounce,
                init: () => {
                  this.isSMS = true;
                  this.isSMSPanel = true;
                  this.isFlashCall = false;
                  this.isFlashCallPanel = false;
                  this.isVoiceCall = false;
                  this.isVoiceCallPanel = false;
                },
                setModal: () => {
                  this.isSMS = true;
                  this.isFlashCall = false;
                  this.isVoiceCall = false;
                  this.showCallModal = true;
                },
                setPanel: () => {
                  this.isSMSPanel = true;
                  this.isFlashCallPanel = false;
                  this.isVoiceCallPanel = false;
                }
              },
              FLASH_CALL: {
                name: 'FLASH_CALL',
                requestDebounce: this.requestFlashCallDebounce,
                init: () => {
                  this.isSMS = false;
                  this.isSMSPanel = false;
                  this.isFlashCall = true;
                  this.isFlashCallPanel = true;
                  this.isVoiceCall = false;
                  this.isVoiceCallPanel = false;
                },
                setModal: () => {
                  this.isSMS = false;
                  this.isFlashCall = true;
                  this.isVoiceCall = false;
                  this.showCallModal = true;
                },
                setPanel: () => {
                  this.isSMSPanel = false;
                  this.isFlashCallPanel = true;
                  this.isVoiceCallPanel = false;
                }
              },
              VOICE_CALL: {
                name: 'VOICE_CALL',
                requestDebounce: this.requestVoiceCallDebounce,
                init: () => {
                  this.isSMS = false;
                  this.isSMSPanel = false;
                  this.isFlashCall = false;
                  this.isFlashCallPanel = false;
                  this.isVoiceCall = true;
                  this.isVoiceCallPanel = true;
                },
                setModal: () => {
                  this.isSMS = false;
                  this.isFlashCall = false;
                  this.isVoiceCall = true;
                  this.showCallModal = true;
                },
                setPanel: () => {
                  this.isSMSPanel = false;
                  this.isFlashCallPanel = false;
                  this.isVoiceCallPanel = true;
                }
              }
            }
          }
    },
    mounted() {
        if (!this.currentChannel) {
          this.phoneChannelActions[this.initialChannel].requestDebounce();
          this.phoneChannelActions[this.initialChannel].init();
          this.currentPhoneTarget = this.initialChannel;
          this.phoneChannel = this.initialChannel;
        } else {
          this.phoneChannelActions[this.currentChannel].init();
          this.phoneChannel = this.currentChannel;
          this.currentPhoneTarget = this.currentChannel;
        }
    },
    methods: {
      setPin(value) {
        this.pin = value;
      },
      closeCallModal() {
        this.showCallModal = false;
      },
      requestChannel(type, comment) {
        this.$http.post(`/otp/recovery/${type}`, {
          requestId: this.requestId
        }).done(data => {
          onCodeResponse(data);
          if (data.resultCode === 'OK' || data.comment === comment) {
            this.phoneChannel = data.obj || "";
          }
        }).fail(() => notify(i18n('confirm_code_generation_failed'), 'danger'));
      },
      sendSmsDebounce: _.debounce(function () {
        this.requestChannel('SMS', 'phone_code_sending_fails');
      }, 2000, {leading: true, trailing: false}),
      requestFlashCallDebounce: _.debounce(function () {
        this.requestChannel('FLASH_CALL', 'failed_to_phone');
      }, 2000, {leading: true, trailing: false}),
      requestVoiceCallDebounce: _.debounce(function () {
        this.requestChannel('VOICE_CALL', 'failed_to_phone');
      }, 2000, {leading: true, trailing: false}),
      sendPhoneRequest() {
        if (this.phoneChannel === this.currentPhoneTarget) {
          this.phoneChannelActions[this.currentPhoneTarget].requestDebounce();
          this.setStartTimer = true;
          return true;
        }
        if (this.phoneChannel !== this.currentPhoneTarget) {
          this.phoneChannelActions[this.phoneChannel].setModal();
          this.setStartTimer = false;
          return false;
        }
      },
      sendPhoneModalRequest() {
        this.phoneChannelActions[this.phoneChannel].setPanel();
        this.currentPhoneTarget = this.phoneChannel;
        this.setStartTimer = true;
        this.phoneChannelActions[this.phoneChannel].requestDebounce();
        this.closeCallModal();
      },
    }
}
</script>
